import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/context/AuthContext.jsx";
import { Loader2 } from "lucide-react";
import routes from "./routes";

export const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, isLoading, isAuthenticated, loadingUserCompany, userCompany } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-muted-foreground">
            Vérification de l'authentification...
          </p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (loadingUserCompany) return <></>;
  if (!userCompany) {
    const allowedRoutesWhenNoUserCompany = [
      routes.settings,
      routes.createAccount
    ];
    if (
      !allowedRoutesWhenNoUserCompany.some((route) =>
        location.pathname.includes(route),
      )
    ) {
      return <Navigate to={routes.createAccount} replace />;
    }
  }

  // Check role-based access if required
  if (requiredRole && user && user.role !== requiredRole) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-destructive mb-2">
            Accès refusé
          </h1>
          <p className="text-muted-foreground">
            Vous n'avez pas les permissions nécessaires pour accéder à cette
            page.
          </p>
        </div>
      </div>
    );
  }

  // Render children if authenticated and authorized
  return <>{children}</>;
};
